// extracted by mini-css-extract-plugin
export default {"modal-wrapper":"DeleteCategoryModalContent_modal-wrapper__3Jpi9"};